export const siteIP = "https://www.msroadbuildersfoundation.com:4000";

export const emailService = "service_0j39lqp";
export const contactFormEmailTemplate = "template_yskzg2r";
export const donationNotificationEmailTemplate = "template_98g2kg4"
export const donationConfirmationEmailTemplate = "template_mrgjos7"
export const emailJSPubKey = "vGlUNrys7yZRY7py5";

export const recaptchaSiteKey = "6Le06XYsAAAAAHxj5GUq46nbr10npwT9p_HTZjiB"

export const stripePubKey =
  "pk_live_51SvPr8EkJkhOYHZdvBLJTX5xeVgPXmAm50Oe4uq8bPfPHpXLwQN3JirMxmQM6VGMXzo3tN0A0CjEQUXEBuA57EYg00MIIUT4A7";

